import { getInfo } from '@Components/Grid/components/Table/formatters';
import { formatters } from 'components/hierarchical-report/utils'

export default function ColorizeNumberFormatter({ info }) {
  const { value } = getInfo(info)
  if (!value) return '--'
  return formatters.colorize(formatters.money()(Number(value)), value)
}

export const colorizeNumberFormatter = value => formatters.colorize(formatters.money()(Number(value)), value)
